// Ceny z paragonów: zapłacona cena jednostkowa, szacunek pozycji listy, zapis kwot.

export interface PricedLine {
  qty: number;
  valueGr: number;
  discountGr: number;
}

/** Zapłacona cena za sztukę albo kg: (wartość − rabaty) / ilość. */
export function paidUnitGr(line: PricedLine): number {
  if (line.qty <= 0) return line.valueGr - line.discountGr;
  return Math.round((line.valueGr - line.discountGr) / line.qty);
}

export interface EstimateItem {
  qty: number | null;
  unit: string | null;
  amountValue: number | null;
  amountUnit: string | null;
}

export interface EstimatePrice {
  /** Cena za sztukę albo za kg (weight). */
  unitGr: number;
  weight: boolean;
  /** Zwykle kupowana ilość (kg dla towarów na wagę) — gdy lista nie mówi, ile. */
  typicalQty?: number | null;
}

/** Ile kilogramów mówi pozycja listy („1,5 kg”, „500 g”, „2× 300 g”); null = nie wiadomo. */
export function itemKg(item: EstimateItem): number | null {
  if (item.amountValue === null || !item.amountUnit) return null;
  const unit = item.amountUnit.toLowerCase();
  const per = unit === 'kg' ? item.amountValue : unit === 'g' ? item.amountValue / 1000 : unit === 'dag' || unit === 'dkg' ? item.amountValue / 100 : null;
  if (per === null) return null;
  return per * (item.qty ?? 1);
}

/** Szacowany koszt pozycji listy według ceny półkowej. */
export function estimateGr(item: EstimateItem, price: EstimatePrice): number {
  if (price.weight) {
    const kg = itemKg(item) ?? price.typicalQty ?? 1;
    return Math.round(price.unitGr * kg);
  }
  return Math.round(price.unitGr * (item.qty && item.qty > 0 ? item.qty : 1));
}

/** 799 → „7,99 zł”; withUnit=false → „7,99”. */
export function formatGr(gr: number, withUnit = true): string {
  const s = (gr / 100).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return withUnit ? `${s} zł` : s;
}
